<div class="card">
  <app-header titulo="Classe Avaliação" descricao="Dados de classe avaliação"></app-header>
  <p-toast />
  <p-table [value]="classeAvaliacoes" dataKey="id" [loading]="loading" #dt [globalFilterFields]="['classeAvaliacao','contaContabil']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <a [routerLink]="['novo']"><button icon="pi pi-plus" label="Novo Cadastro" pButton></button></a>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Classe Avaliacao</th>
            <th>Conta Contabil</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-classeAvaliacao>
        <tr>
            <td>{{ classeAvaliacao.classeAvaliacao }}</td>
            <td>{{ classeAvaliacao.contaContabil }}</td>
            <td>
              <a [routerLink]="['editar', classeAvaliacao.id]">
                <p-button icon="pi pi-pencil"
                          severity="primary"
                          class="m-2"
                          [rounded]="true"
                          [outlined]="true" >
                </p-button>
              </a>

              <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [rounded]="true"
                        [outlined]="true"
                        (onClick)="confirmarExclusao(classeAvaliacao.id)" />
            </td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="10">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>
  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
